import styled from "styled-components";
import
  {
    HeaderContainer,
    SectionTitle,
  } from "../SectionHeader/SectionHeader.styled";

export const ServiceCards = styled.div`
  && {
    display: grid;
    grid-template-columns: repeat(3, 1fr);
    width: 100%;

    gap: 48px;

    @media (max-width: 900px) {
      grid-template-columns: repeat(2, 1fr);
    }

    @media (max-width: 600px) {
      grid-template-columns: 1fr;
    }

    @media (max-width: 768px) {
      ${ HeaderContainer } {
        margin: 0;
      }
    }
    ${ SectionTitle } {
      font-size: 40px;
    }
  }
`;
